import React, { useEffect, cloneElement, useRef, useState } from "react";
import { NavLink, useRouteMatch, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSubcategory } from "../actions";
import useClickOutside from "../../../../../hooks/useClickOutside";

import "./index.scss";


export const Dropdown = ({ billing, item, showAppealModal, mobile: isMobile }) => {

	const [showSub, setShowSub] = useState(false);
	const [position, setPosition] = useState(null);
	const isMinimized = useSelector(({nav}) => !nav.open);
	const subCategory = useSelector(({ nav }) => nav.subCategory);
	const hasSubscription = useSelector(({ auth }) => auth.profile && auth.profile.subscription && auth.profile.subscription.id);
	const dark = useSelector(({ theme }) => theme.globalTheme === "dark");
	const minimizedMenuRef = useRef();
	const dispatch = useDispatch();
	const bannerHeight = useSelector(({ nav }) => nav.bannerHeight);
	const { pathname } = useLocation();


	const { icon: Icon, url, name, children, id } = item;

	let isActive = (path) => useRouteMatch({ path: path });

	if(!isMobile) {
		useClickOutside(minimizedMenuRef, () => {
			setShowSub(false)
		});
	}

	useEffect(() => {
		if(minimizedMenuRef && minimizedMenuRef.current && showSub) {
			setPosition(minimizedMenuRef.current.parentElement.offsetTop)
		}
	}, [minimizedMenuRef, showSub]);

	useEffect(() => {
		if(pathname.startsWith("/settings/")) {
			dispatch(setSubcategory(null))
		}
	}, [pathname]);

	let a = isActive(url);

	useEffect(() => {
		if(!subCategory.length && a && !isMinimized) {
			toggle()
		}
	}, [a])

	let toggle = () => {

		if (isMinimized && !isMobile) {

			if (showSub) {
				setShowSub(false);
			} else {
				setShowSub(true);
			}

		} else {

			if (subCategory.includes(name)) {
				dispatch(setSubcategory(null));
			} else if (children && children.length) {
				dispatch(setSubcategory(name));
			} else {
				dispatch(setSubcategory(name));
			}

		}
	};

	return <li className="nav-item" id={id}>

		<a className={`nav-link ${!isMinimized || isMobile ? 'has-dropdown' : ''} ${subCategory.includes(name) ? 'active' : ''}`} onClick={toggle}>
			{cloneElement(Icon, { active: url, dark })}
			<span>{name}</span>
		</a>

		<ul className={`nav-dropdown-items ${subCategory.includes(name) ? 'open' : ''}`}>
			{children.map(({ name, url, isBeta, isNew, icon: Icon, mobile, id, attributes }, key) => {

				if (attributes && attributes.rel === "documentation") {
					return <li className="nav-item" key={`${key}`}>
						<a className="nav-link" href={url} {...attributes}>
							{cloneElement(Icon, { active: isActive(url), dark })}
							<span>
								{name}
							</span>
						</a>
					</li>
				} else {

					if (name === 'Appeals' && !hasSubscription) {
						return <li key={key} className="nav-item">
							<a className="nav-link" href={undefined} onClick={() => {
								showAppealModal()
								if (isMinimized && !isMobile) {
									let index = subCategory.indexOf(name);
									subCategory.splice(index, 1);
									dispatch(setSubcategory(subCategory));
								}
							}}>
								{Icon ? cloneElement(Icon, { active: isActive(url), dark }) : <i/>}
								<span>{name}</span>
							</a>
						</li>
					}

					if(billing === "DEFAULT" && id === "accounting") {
						return null
					}

					return <li className="nav-item" key={`${key}`}>
						<NavLink className="nav-link" to={url} {...attributes} onClick={() => {
							if (isMinimized && !isMobile) {
								let index = subCategory.indexOf(name);
								subCategory.splice(index, 1);
								dispatch(setSubcategory(subCategory));
							}
						}}>
							{Icon ? cloneElement(Icon, { active: isActive(url), dark }) : <i/>}
							<span>
								{name}
							</span>
							{isBeta &&
								<div className="d-flex ml-auto">
									<span className="badge badge-paylixecommerce dropdown-beta-link" data-tooltip-id="beta">
										<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M9.33333 10.5002C9.64275 10.5002 9.9395 10.6231 10.1583 10.8419C10.3771 11.0607 10.5 11.3574 10.5 11.6668C10.5 11.3574 10.6229 11.0607 10.8417 10.8419C11.0605 10.6231 11.3572 10.5002 11.6667 10.5002C11.3572 10.5002 11.0605 10.3772 10.8417 10.1585C10.6229 9.93966 10.5 9.64292 10.5 9.3335C10.5 9.64292 10.3771 9.93966 10.1583 10.1585C9.9395 10.3772 9.64275 10.5002 9.33333 10.5002ZM9.33333 3.50016C9.64275 3.50016 9.9395 3.62308 10.1583 3.84187C10.3771 4.06066 10.5 4.35741 10.5 4.66683C10.5 4.35741 10.6229 4.06066 10.8417 3.84187C11.0605 3.62308 11.3572 3.50016 11.6667 3.50016C11.3572 3.50016 11.0605 3.37725 10.8417 3.15845C10.6229 2.93966 10.5 2.64292 10.5 2.3335C10.5 2.64292 10.3771 2.93966 10.1583 3.15845C9.9395 3.37725 9.64275 3.50016 9.33333 3.50016ZM5.25 10.5002C5.25 9.57191 5.61875 8.68167 6.27513 8.02529C6.9315 7.36891 7.82174 7.00016 8.75 7.00016C7.82174 7.00016 6.9315 6.63141 6.27513 5.97504C5.61875 5.31866 5.25 4.42842 5.25 3.50016C5.25 4.42842 4.88125 5.31866 4.22487 5.97504C3.5685 6.63141 2.67826 7.00016 1.75 7.00016C2.67826 7.00016 3.5685 7.36891 4.22487 8.02529C4.88125 8.68167 5.25 9.57191 5.25 10.5002Z" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
										</svg>
										<div>Beta</div>
									</span>
								</div>
							}
						</NavLink>
					</li>
				}

			})}
		</ul>

		{isMobile ? null : <ul
			className={`nav-dropdown-items-minimized ${showSub ? 'open' : ''}`}
		   	style={showSub ? { top: `${(minimizedMenuRef.current ? (minimizedMenuRef.current.parentElement.offsetTop + bannerHeight) : 400)}px` } : {}} ref={minimizedMenuRef}>
			<li className="nav-item nav-item-title">{name}</li>

			{children.map(({ name, url, icon: Icon, attributes }, key) => {

				if (attributes && attributes.rel === "documentation") {
					return <li className="nav-item" key={`${key}`}>
						<a className="nav-link" href={url} {...attributes}>
							{cloneElement(Icon, { active: isActive(url), dark })}
							<span>
								{name}
							</span>
						</a>
					</li>
				} else {

					if (name === 'Appeals' && !hasSubscription) {
						return <li key={key} className="nav-item">
							<a className="nav-link" href={undefined} onClick={() => {
								showAppealModal()
								if (isMinimized && !isMobile) {
									let index = subCategory.indexOf(name);
									subCategory.splice(index, 1);
									dispatch(setSubcategory(subCategory));
								}
							}}>
								{Icon ? cloneElement(Icon, { active: isActive(url), dark }) : <i/>}
								<span>{name}</span>
							</a>
						</li>
					}

					return <li className="nav-item" key={`${key}`}>
						<NavLink className="nav-link" to={url} {...attributes} onClick={() => {
							setShowSub(false)
						}}>
							{Icon ? cloneElement(Icon, { active: isActive(url), dark }) : <i/>}
							<span>
								{name}
							</span>
						</NavLink>
					</li>
				}

			})}
		</ul>}
	</li>
}

export default Dropdown;
